/* eslint-disable no-unused-vars */
import PricesService from '@/services/prices';
import { SET_PRICES } from './types';

export async function getPrices({commit}) {
  const {data} = await PricesService.getPrices();
  commit(SET_PRICES, data.data.prices);
  return data.data.prices;
}